<template>
  <div class="page-wrap" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="24" :lg="24" :xl="16">
        <el-form
            ref="formRef"
            :model="form"
            :rules="rules"
            label-position="top"
            hide-required-asterisk
        >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="24">
              <fieldset>
                <legend>O'zbekcha</legend>
                <el-form-item
                    label="Savol"
                    prop="question.uz"
                >
                  <el-input
                      placeholder="Savolni kiriting (Uz)"
                      v-model.number="form.question.uz"
                      type="text"
                      autocomplete="off"
                  />
                </el-form-item>
                <el-form-item
                    label="Javob matni (Uz)"
                    prop="answer.uz"
                >
                  <el-input
                      style="width: 100%"
                      v-model.number="form.answer.uz"
                      type="textarea"
                      rows="10"
                      autocomplete="off"
                  />
                </el-form-item>
              </fieldset>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="24">
              <fieldset>
                <legend>Ruscha</legend>
                <el-form-item
                    label="Savol"
                    prop="question.ru"
                >
                  <el-input
                      placeholder="Savolni kiriting (Ru)"
                      v-model.number="form.question.ru"
                      type="text"
                      autocomplete="off"
                  />
                </el-form-item>
                <el-form-item
                    label="Javob matni (Ru)"
                    prop="answer.ru"
                >
                  <el-input
                      v-model.number="form.answer.ru"
                      type="textarea"
                      autocomplete="off"
                      rows="10"
                  />
                </el-form-item>
              </fieldset>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="24">
              <fieldset>
                <legend>Inglizcha</legend>
                <el-form-item
                    label="Savol (En)"
                    prop="question.en"
                >
                  <el-input
                      placeholder="Savolni kiriting (En)"
                      v-model.number="form.question.en"
                      type="text"
                      autocomplete="off"
                  />
                </el-form-item>
                <el-form-item
                    label="Javob matni (En)"
                    prop="answer.en"
                >
                  <el-input
                      v-model="form.answer.en"
                      type="textarea"
                      autocomplete="off"
                      rows="10"
                  />
                </el-form-item>
              </fieldset>

            </el-col>
            <el-form-item
                label="Tartibini kiriting"
                prop="order"
            >
              <el-input
                  v-model="form.order"
                  type="number"
              />
            </el-form-item>
          </el-row>
          <div class="mt-15 text-right">
            <router-link to="/app/faq/list" class="el-button el-button--danger">
              Bekor qilish
            </router-link>
            <el-button type="primary" @click="submitForm(formRef)">Saqlash</el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>

import {onMounted, ref} from "vue";
import {ElMessage} from "element-plus";
import {useRoute, useRouter} from "vue-router";
import http from "@/http";

const router = useRouter();
const route = useRoute();
const {id} = route.params;
const formRef = ref();
const loading = ref(false);
let form = ref({
  question: {
    uz: null,
    ru: null,
    en: null,
  },
  answer: {
    uz: null,
    ru: null,
    en: null,
  },
  order: 0
})
const rules = ref({
  question:
      {
        uz: {required: true, message: 'Sarlavha majburiy (Uz)', trigger: 'blur'},
        ru: {required: true, message: 'Sarlavha majburiy (Ru)', trigger: 'blur'},
        en: {required: true, message: 'Sarlavha majburiy (En)', trigger: 'blur'}
      },
  answer: {
    uz: {required: true, message: 'Asosiy matin (Uz) majburiy', trigger: 'blur'},
    ru: {required: true, message: 'Asosiy matin (Ru) majburiy', trigger: 'blur'},
    en: {required: true, message: 'Asosiy matin (En) majburiy', trigger: 'blur'},
  }

})

const getFaqById = () => {
  http.get(`api/v2/info/faq/admin/${id}`)
      .then(({data}) => {
        form.value = data
      })
      .catch(() => {
        ElMessage.error(`Hatolik qayta urinib ko'ring`);
      })
      .finally(() => {
        loading.value = false
      })
}

onMounted(() => {
  if (id) {
    getFaqById()
  }
})
const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid) => {
    if (valid) {
      loading.value = true;
      let httpTemp;
      if (id) {
        httpTemp = http.put(`api/v2/info/faq/${id}`, form.value)
      } else {
        httpTemp = http.post('api/v2/info/faq', form.value)
      }

      httpTemp.then(() => {
        ElMessage.success("Muvaffaqqiyatli saqlandi");
        router.go(-1);
      })
          .catch(() => {
            ElMessage.error(`Hatolik qayta urinib ko'ring`);
          })
          .finally(() => {
            loading.value = false
          })
    }
  })
}
</script>

<style scoped lang="scss">
.text-right {
  text-align: right;
}

fieldset {
  border: 1px solid #f4f4f4;
  padding: 10px;
  margin-bottom: 10px;
}
</style>